export default ['sk', 'en', 'de', 'nl'];
